import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationType } from '../models/application-type.enum';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TailoredShareholdersService {

  private cache: Map<String, any[]> = new Map<ApplicationType, any[]>();

  constructor(private http: HttpClient, private router: Router) { }

  getFundsDocuments(applicationId: ApplicationType, pageNumber: number, recordsPerPage: number): Observable<any> {
    let cacheKey = applicationId + pageNumber + recordsPerPage;

    if (this.cache.has(cacheKey)) {
      return of(this.cache.get(cacheKey));
    }

    const queryParams: { applicationId?: ApplicationType, pageNumber?: number, recordsPerPage?: number } = {};
    if (applicationId) {
      queryParams.applicationId = applicationId;
    }
    if(pageNumber)
    {
      queryParams.pageNumber= pageNumber;
    }
    if(recordsPerPage)
    {
      queryParams.recordsPerPage=recordsPerPage;
    }

    return this.http.get<any>(`${environment.apiUrl}/v2/prospectus-documents`, { params: queryParams }).pipe(
      catchError(err => {
        this.router.navigate(['error'], { queryParams: { c: err.status } });
        return null;
      }),
      map((res: any) => ({
        data: Object.values(res.fundsDocuments).filter((item: any) => item.fundInformation !== null).map((item: any) => {
          if (item.fundInformation) {
            item.fundInformation._cleanLegalName = '';
            if (item.fundInformation.legalName) {
              item.fundInformation._cleanLegalName = item.fundInformation.legalName.replace(/<(sup|sub)>.{1,7}<\/(sup|sub)>/, '');
            }
          }
          return item;
        }),
        totalSize:res.totalSize
      })),
      tap(res => {
        this.cache.set(cacheKey, res);
      })
    );

  }

  getSearchedDocuments(searchString:string): Observable<any[]> {
    let cacheKey = searchString;

    if (this.cache.has(cacheKey)) {
      return of(this.cache.get(cacheKey));
    }

    const queryParams: { searchString?:string } = {};
    if (searchString) {
      queryParams.searchString = searchString;
    }

    return this.http.get<any>(`${environment.apiUrl}/v2/prospectus-search`, { params: queryParams }).pipe(
      catchError(err => {
        this.router.navigate(['error'], { queryParams: { c: err.status } });
        return null;
      }),
      map((res: any) => {
        return Object.values(res.fundsDocuments).filter((item: any) => item.fundInformation !== null).map((item: any) => {
          if (item.fundInformation) {
            item.fundInformation._cleanLegalName = '';
            if (item.fundInformation.legalName) {
              item.fundInformation._cleanLegalName = item.fundInformation.legalName.replace(/<(sup|sub)>.{1,7}<\/(sup|sub)>/, '');
            }
          }
          return item;
        });
      }),
      tap(res => {
        this.cache.set(cacheKey, res);
      })
    );
  }


}

